module.exports = __webpack_public_path__ + "img/governance.6193bda5.png";